<template>
  <div>
    <b-row class="m-0 w-full" v-if="showComments">
      <b-col
        lg="12">
          <h5 class="mt-2 mb-0">{{$t('newsletter.comments.title')}}</h5>
      </b-col>
    </b-row>
    <b-row class="m-0" v-if="showComments">
      <b-col
        lg="12">
        <vs-divider></vs-divider>
        <span class="small" v-if="!hasComments">{{$t('newsletter.comments.not_found')}}</span>
        <ul class="vx-timeline">
            <li v-for="item in comments" :key="item.id">
                <div v-if="showHandlingComment"
                  class="timeline-icon cursor-pointer" :class="item.public_access? 'bg-primary' : 'bg-danger'"
                    @click="handlingComment(item)"
                    v-tooltip="{content: item.public_access ? 'Bloquear comentário' : 'Liberar comentário', delay: { show: 500, hide: 100 }}">
                    <feather-icon :icon="item.public_access ?  'CheckIcon' : 'XIcon'" class="text-white stroke-current w-5 h-5" />
                </div>
                <div class="timeline-info">
                    <p class="text-break break-all whitespace-pre-line">{{ item.content }}</p>
                </div>
                <small class="text-grey activity-e-time">{{ formatTime(item.created_at) }}</small>
            </li>
        </ul>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import {
  BForm,
  BFormGroup,
  BRow,
  BCol,
  BLink,
  BCard,
  BCardText,
  BCardTitle,
  BCardFooter,
  BImg,
  BInputGroup,
  BFormInput,
  BFormTextarea,
  BButton,
  BAlert,
  VBTooltip,
  BModal,
} from 'bootstrap-vue'

import NewsletterService from '@/services/api/NewsletterService'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BInputGroup,
    BFormInput,
    BFormTextarea,
    BLink,
    BCard,
    BCardText,
    BCardTitle,
    BCardFooter,
    BImg,
    BButton,
    BAlert,
    VBTooltip,
    BModal,
    MediaList,
  },
  props: {
    newsletterId: {
      type: Number,
      default: null
    },
    comments: {
      type: Array,
      default: [],
    },
    showComments: {
      type: Boolean,
      default: true,
    },
    showHandling: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      service: null
    }
  },
  watch: {

  },
  computed: {
    hasComments() {
      return (this.comments && this.comments.length > 0)
    },
    hasNewsletter() {
      return (this.newsletter && this.newsletter.id != null)
    },
    showHandlingComment(){
      return (this.showComments && this.$acl.hasAnyPermission('newsletters_moderator.handling'))
    }

  },
  methods: {
    formatTime(time) {
      const thenEpoch = (new Date(time)).getTime()
      return this.readableHumanTime(thenEpoch)
    },
    handlingComment(item){
      this.$vs.loading()

      item.public_access = !item.public_access

      const data = {
        public_access: item.public_access
      }

      this.service.handlingComment(this.newsletterId, item.id, data).then(
        data => {
          this.notifySuccess(this.$vs, this.$t('messages.success'))
        },
        error => {
          this.showErrors(this.$validator, error)
          this.notifyError(this.$vs,this.$t('messages.error'))
        }
      ).finally(() => { this.$vs.loading.close() })

    }
  },
  mounted() {


  },
  beforeMount() {
    this.service = NewsletterService.build(this.$vs)
  },
}
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/vuexy/components/vxTimeline.scss";
</style>

